import {
  Form,
  Button,
  Row,
  Col,
  Divider,
  message,
  Spin,
  Skeleton,
  Steps,
  Typography,
} from "antd";
import {
  UserOutlined,
  SolutionOutlined,
  LoadingOutlined,
  SmileOutlined,
  CreditCardOutlined,
} from "@ant-design/icons";

import SelectTicketType from "./formComponents/selectTicketType";
import Payments from "./formComponents/payments";
import Billing from "./formComponents/billing";
import Confirmation from "./formComponents/confirmation";
import React, { useCallback, useEffect, useState } from "react";

import Axios from "axios";
import { endpoints } from "../../auth/apiRoute";
import { getEventImageUrl } from "../../eventImages";
const { Title, Text, Paragraph } = Typography;
const layout = {
  wrapperCol: {
    span: 24,
  },
};
const { Step } = Steps;
const gutterLayout = { xs: 8, sm: 16, md: 24, lg: 32 };

const validateMessages = {
  required: "This field is required.",
  types: {
    email: "This is not a valid email.",
    number: "This is not a valid number.",
  },
  number: {
    range: "This number is outside the allowed range.",
  },
};

const trimFormValues = (value) => {
  if (typeof value === "string") {
    return value.trim();
  }

  if (Array.isArray(value)) {
    return value.map(trimFormValues);
  }

  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [key, trimFormValues(entry)])
    );
  }

  return value;
};

const Checkoutform = (appProps) => {
  const eventKey = appProps.eventKey || "end-of-summer";
  console.log(appProps);
  const [ticketQuantities, setTicketQuantities] = useState({});
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [loadingCustomer, setLoadingCustomer] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [confirmationMessage, setConfirmationMessage] = useState();
  const [formValues, setFormValues] = useState({});
  const [customerId, setCustomerId] = useState();
  const [customerEmail, setCustomerEmail] = useState();
  const [eventName, setEventName] = useState("");
  const [eventDetails, setEventDetails] = useState(null);
  const [eventNotFound, setEventNotFound] = useState(false);
  const [eventStatus, setEventStatus] = useState();
  const [ticketTypes, setTicketTypes] = useState([]);
  const [loadingEvent, setLoadingEvent] = useState(true);

  const loadEvent = useCallback(async () => {
    setLoadingEvent(true);
    setEventNotFound(false);
    try {
      const response = await Axios.get(endpoints.events.detail(eventKey));
      const data = response.data;
      setEventName(data.name);
      setEventDetails(data);
      setEventStatus(data.status);
      setTicketTypes(data.ticketTypes || []);
    } catch (error) {
      console.log(error);
      if (error.response && error.response.status === 404) {
        setEventNotFound(true);
      }
      setEventDetails(null);
    }
    setLoadingEvent(false);
  }, [eventKey]);

  useEffect(() => {
    loadEvent();
  }, [loadEvent]);

  const onFinish = async (values) => {
    const trimmedValues = trimFormValues(values);
    form.setFieldsValue(trimmedValues);

    const cartItems = ticketTypes
      .map((ticketType) => ({
        ticketTypeId: ticketType.id,
        quantity: ticketQuantities[ticketType.id] || 0,
      }))
      .filter((item) => item.quantity > 0);
    const ticketAmount = cartItems.reduce(
      (total, item) => total + item.quantity,
      0
    );

    if (currentStep === 0 && cartItems.length === 0) {
      message.error("Please select at least one ticket or item.");
      return;
    }
    setFormValues({ ...formValues, ...trimmedValues });

    var confirmationText = "Success! You will receive a confirmation shortly.";

    if (currentStep == 0) {
      setCurrentStep(currentStep + 1);
    }
    if (currentStep == 1) {
      await checkAndCreateCustomer(trimmedValues);
    }
    if (currentStep == 2) {
      if (
        trimmedValues.paymentMethod &&
        trimmedValues.paymentMethod == "check"
      ) {
        confirmationText = "Success! You will receive a confirmation shortly.";
      }
      setConfirmationMessage(confirmationText);
      console.log(formValues);
      var newFormValues = {
        ...formValues,
        ...trimmedValues,
        ...{ customerId: customerId },
        ...{ eventKey: eventKey },
        ...{ cartItems: cartItems },
        ...{ ticketAmount: ticketAmount },
      };

      console.log(newFormValues);
      submitInfo(newFormValues);
    }
  };

  const checkAndCreateCustomer = async (values) => {
    var baseUrl = endpoints.general.createCustomer;

    setLoadingCustomer(true);
    try {
      const response = await Axios.post(baseUrl, values);
      console.log(response);
      setLoadingCustomer(false);

      if (response.status == 200) {
        setCustomerId(response.data.customerId);
        setCustomerEmail(values.user.email);
        setCurrentStep(currentStep + 1);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }

      setLoadingCustomer(false);
    }
  };
  const submitInfo = async (values) => {
    var baseUrl = endpoints.endOfSummer.charge;

    setLoading(true);
    try {
      const response = await Axios.post(baseUrl, values);
      console.log(response);
      if (response.status == 200) {
        setCurrentStep(currentStep + 1);
        form.resetFields();
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };

  const onSelectTicket = (ticketTypeId, amount) => {
    setTicketQuantities((current) => ({
      ...current,
      [ticketTypeId]: amount,
    }));
  };

  const goPrevious = () => {
    setCurrentStep(currentStep - 1);
  };
  const showFormContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <SelectTicketType
            ticketTypes={ticketTypes}
            quantities={ticketQuantities}
            onChange={onSelectTicket}
          />
        );
      case 1:
        return (
          <Spin spinning={loadingCustomer}>
            <Billing />
          </Spin>
        );
      case 2:
        return <Payments email={customerEmail} />;
      case 3:
        return <Confirmation confirmationMessage={confirmationMessage} />;
      default:
    }
  };
  const showTotal = () => {
    const selectedItems = ticketTypes.filter(
      (ticketType) => (ticketQuantities[ticketType.id] || 0) > 0
    );
    return (
      <div className="totalAmount">
        <h4>Total: {totalPrice()}</h4>
        <Divider />
        {selectedItems.length ? (
          selectedItems.map((ticketType) => (
            <p key={ticketType.id}>
              {ticketType.name}: {ticketQuantities[ticketType.id]} × ${
                Number(ticketType.unitPrice || 0).toFixed(2)
              }
            </p>
          ))
        ) : (
          <p>No items selected</p>
        )}
      </div>
    );
  };
  const totalPrice = () => {
    var formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });
    var total = ticketTypes.reduce(
      (sum, ticketType) =>
        sum +
        (ticketQuantities[ticketType.id] || 0) *
          Number(ticketType.unitPrice || 0),
      0
    );

    return formatter.format(total);
  };
  const renderEventHero = () => {
    if (!eventDetails) return null;
    return (
      <section className="eventDetail-hero">
        <div className="eventDetail-imageFrame">
          <img src={getEventImageUrl(eventDetails)} alt={eventDetails.name} />
        </div>
        <div className="eventDetail-heroText">
          <Text className="eventDetail-kicker">HANYC Event</Text>
          <Title level={1}>{eventDetails.name}</Title>
          <Paragraph>
            {eventDetails.description ||
              "Register below to reserve tickets for this HANYC event."}
          </Paragraph>
        </div>
      </section>
    );
  };

  if (appProps.isLocked) {
    return (
      <Title level={4}>
        The event is now closed. We would like to thank all those who bought
        tickets.
      </Title>
    );
  }

  if (loadingEvent) {
    return (
      <div className="eventDetail-page">
        <div className="eventDetail-loadingCard">
          <Skeleton active />
        </div>
      </div>
    );
  }

  if (eventNotFound) {
    return (
      <div className="eventDetail-page">
        <div className="eventDetail-messageCard">
          <Title level={4}>We couldn't find that event.</Title>
        </div>
      </div>
    );
  }

  if (eventStatus !== "on-sale") {
    return (
      <div className="eventDetail-page">
        {renderEventHero()}
        <div className="eventDetail-messageCard">
          <Title level={4}>
            Thank you for your interest in {eventName || "this event"}.
          </Title>
          <Paragraph>Ticket sales are not currently active.</Paragraph>
        </div>
      </div>
    );
  }

  if (ticketTypes.length === 0) {
    return (
      <div className="eventDetail-page">
        {renderEventHero()}
        <div className="eventDetail-messageCard">
          <Title level={4}>Thank you for your interest in this event.</Title>
        </div>
      </div>
    );
  }

  return (
    <div className="eventDetail-page">
      {renderEventHero()}
      <div className="appCard eventDetail-checkoutCard">
        <Title level={2} className="appTitle">
          Registration
        </Title>

        <Steps
          current={currentStep}
          size="small"
          // onChange={(value) => setCurrentStep(value)}
        >
          <Step title="Ticket" icon={<UserOutlined />} />
          <Step title="Billing" icon={<SolutionOutlined />} />
          <Step
            title="Sending Invoice"
            icon={loading ? <LoadingOutlined /> : <CreditCardOutlined />}
          />
          <Step title="Confirmation" icon={<SmileOutlined />} />
        </Steps>
        <Row gutter={gutterLayout}>
          <Col xs={24} md={currentStep == 3 ? 24 : 18} style={{ marginTop: "2rem" }}>
            <Form
              form={form}
              {...layout}
              name="nest-messages"
              layout="vertical"
              onFinish={onFinish}
              validateMessages={validateMessages}
              initialValues={{
                guests: [{ first: "", last: "" }],

                paymentMethod: "check",
              }}
            >
              {showFormContent()}

              {currentStep == 3 ? (
                <></>
              ) : (
                <Form.Item>
                  <Row gutter={gutterLayout}>
                    {" "}
                    {currentStep == 0 ? (
                      <></>
                    ) : (
                      <Col span={12}>
                        <Button
                          type="primary"
                          disabled={loading ? true : false}
                          onClick={goPrevious}
                          block
                        >
                          Previous
                        </Button>
                      </Col>
                    )}
                    <Col span={12}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        disabled={loading ? true : false}
                        block
                      >
                        {currentStep == 2 ? "Confirm" : "Next"}
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
              )}
            </Form>
          </Col>
          {currentStep == 3 ? (
            <></>
          ) : (
            <Col xs={24} md={6} style={{ marginTop: "2rem" }}>
              {showTotal()}
            </Col>
          )}
        </Row>
      </div>
    </div>
  );
};

export default Checkoutform;
